import React, { useState, useEffect, useRef } from "react"

import {
  Container,
  HeadingDesktop,
  HeadingMobile,
  List,
  TableOfContentsDesktop,
  VideoMetaDesktop,
  TableOfContentsMobile,
  Scroll,
  ScrollContainer,
  ScrollableGrid,
  VideoMetaMobile,
  VideoImage,
} from "./styles"

const VideoGallery = ({
  elRef,
  hideOnPageLoad,
  dataId,
  title,
  subtitle,
  videos,
  videoMeta,
  onVideoSelection = () => {},
  ...props
}) => {
  const [activeVideoIdx, setActiveVideoIdx] = useState(videos ? 0 : -1)
  const handleVideoSelection = (idx) => {
    setActiveVideoIdx(idx)
    onVideoSelection()
  }
  const handleOnKeyPress = (event, idx) => {
    event.preventDefault()

    if (event.key === "Enter" || event.code === "Space") {
      handleVideoSelection(idx)
    }
  }

  // set correct height of the scrollable video meta container
  const refList = useRef(null)
  useEffect(() => {
    let initialized = false

    const handleResize = () => {
      const listElement = refList.current
      const [videoElement, metaElement] = listElement.children
      if (!(videoElement && metaElement)) {
        return
      }

      // calculate correct video height based on 16:9 aspect ratio
      const { clientWidth: w, clientHeight: h } = videoElement
      const videoHeight = w / h > 0.5625 ? w * 0.5625 : h

      if (initialized || metaElement.clientHeight > videoHeight) {
        metaElement.style.height = `${videoHeight}px`
        metaElement.style.overflowY = "scroll"
        initialized = true
      }
    }

    // call on initial load
    setTimeout(handleResize, 0)

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <Container ref={elRef} hideOnPageLoad={hideOnPageLoad} data-exp-id={dataId} {...props}>
      <HeadingDesktop title={title} subtitle={subtitle} />
      <HeadingMobile title={title} subtitle={subtitle} />
      <List ref={refList}>
        {activeVideoIdx > -1 && videos[activeVideoIdx]}
        <TableOfContentsDesktop>
          {videoMeta.map((meta, idx) => (
            <VideoMetaDesktop
              key={meta.title}
              active={activeVideoIdx === idx}
              onClick={() => handleVideoSelection(idx)}
            >
              <h3 tabIndex={0} onKeyPress={(event) => handleOnKeyPress(event, idx)}>
                {meta.title}
              </h3>
              <div dangerouslySetInnerHTML={{ __html: meta.description }} />
            </VideoMetaDesktop>
          ))}
        </TableOfContentsDesktop>
        <TableOfContentsMobile>
          <Scroll count={videos.length} />
          <ScrollContainer>
            <ScrollableGrid>
              {videoMeta.map((meta, idx) => (
                <VideoMetaMobile
                  key={meta.title}
                  active={activeVideoIdx === idx}
                  onClick={() => handleVideoSelection(idx)}
                >
                  <VideoImage
                    url={`https://content.jwplatform.com/v2/media/${videos[idx].props.videoId}/poster.jpg?width=320`}
                    active={activeVideoIdx === idx}
                  />
                  <h3 tabIndex={0} onKeyPress={(event) => handleOnKeyPress(event, idx)}>
                    {meta.title}
                  </h3>
                </VideoMetaMobile>
              ))}
            </ScrollableGrid>
          </ScrollContainer>
        </TableOfContentsMobile>
      </List>
    </Container>
  )
}

export default VideoGallery
